import { SelectionOption } from '../../../../../../types/Survey/Element'

export type Option = SelectionOption & { selected: boolean }

type Props = {
  options: Option[]
  toggle: (uuid: string) => () => void
}

const List: React.FC<Props> = ({ options, toggle }) => {
  return (
    <div className="flex flex-col gap-2 mt-3 w-full">
      {options.map((o: Option) => (
        <div
          key={o.uuid}
          className={`truncate py-2 px-2 transition-all cursor-pointer border border-blue ${
            o.selected ? 'bg-blue text-white' : 'text-blue bg-white hover:bg-blue hover:bg-opacity-10'
          }`}
          onClick={toggle(o.uuid)}
        >
          {o.value}
        </div>
      ))}
    </div>
  )
}

export default List
